import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import {
    PageTitle,
    Loading,
    Button,
    DeviceSerialQrCodeModal
} from '../root/components/common'
import { useLocation, withRouter } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import * as actions from './actions'
import { enqueueSnackbar } from '../root/actions'
import { NetworkDevicesTable } from '../network-devices/components/network-devices-table'
import { isEmpty } from 'lodash'
import classNames from 'classnames'
import { useDevicesFilters } from '../root/components/common/device-filters/use-device-filters'
import {
    urlToSearchState,
    useSyncUrlState
} from 'web/src/utils/hooks/useSyncUrlState'
import { useReportTypes } from '../root/hooks/useReportTypes'
import { prepareFilters } from '../root/components/common/device-filters/utils'
import { UserPermissions } from '../../services/permissions'
import { downloadFile } from 'web/src/utils'
import { LOCAL_LOCALE_KEY } from '../root/constants'
import { getFileForExport } from '../devices/api/device-api'
import { NetworkDeviceFilters } from 'web/src/app/root/components/common/network-device-filters/network-device-filters'
import { ExportMenu } from '../root/components/common/export-menu'
const useStyles = makeStyles(theme => ({
    switcher: {
        marginRight: 12
    },
    wrapper: {
        height: 'calc(100% - 125px)'
    },
    nameLink: {
        color: theme.textPrimary,
        textDecoration: 'none',
        fontWeight: 'bold',
        cursor: 'pointer'
    },
    actions: {
        display: 'flex',
        justifyContent: 'center'
    },
    icon: {
        color: theme.primary,
        cursor: 'pointer'
    },
    batteryWrapper: {
        display: 'flex',
        justifyContent: 'center'
    },
    statusWrapper: {
        display: 'flex',
        justifyContent: 'center'
    },
    modalButtons: {
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: 15
    },
    modalButton: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: 15
    },
    pickerWrapper: {
        marginTop: 15
    },
    pageTitle: {
        justifyContent: 'space-between'
    },
    filtersWrapper: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        paddingBottom: 8,
        gap: 10
    },
    exportBtnsWrapper: {
        display: 'flex',
        gap: '6px',
        marginRight: '16px'
    },
    loader: {
        top: '50vh',
        zIndex: 9,
        position: 'absolute',
        left: '20%',
        right: 0,
        marginLeft: 'auto',
        marginRight: 'auto'
    },
    disabledWrapper: {
        opacity: 0.3,
        pointerEvents: 'none'
    }
}))

function LocationNetworkDevices(props) {
    const classes = useStyles()
    const locationId = props.locationId || props.match.params.locationId
    const isNew = locationId === 'new'

    const {
        isDevicesToMoveMode,
        setIsDevicesToMoveMode,
        noTitle,
        className,
        embeded,
        noFilters
    } = props

    const { isLoading, locale } = useSelector(state => state.main)
    const { locationNetworkDevices, location } = useSelector(
        state => state.locations
    )

    const [currentDeviceSerial, setCurrentDeviceSerial] = useState(null)
    const [isOpenQrModal, setIsOpenQrModal] = useState(false)
    const browserLocation = useLocation()

    // TODO: we should create and add here hook for network devices filters.
    const [filters, d] = useDevicesFilters(
        urlToSearchState(browserLocation),
        UserPermissions.isAllOriginalGranted()
    )
    const canUpdate =
        (location?.is_assigned &&
            UserPermissions.location(location?.customer_id).update) ||
        (UserPermissions.isAllOriginalGranted() &&
            UserPermissions.isOriginalEntity(location?.customer_id))

    useSyncUrlState(filters)
    const { reportSeverityGroups } = useReportTypes()
    const [isExporting, setIsExporting] = useState(false)

    const dispatch = useDispatch()

    const onSaveMove = devices => {
        const devicesToMove = devices.filter(d => d.is_fresh)
        if (devicesToMove.length === 0) {
            dispatch(
                enqueueSnackbar({
                    message: locale.locations.noDevicesAdded,
                    options: {
                        variant: 'info'
                    }
                })
            )
            return
        }
        dispatch(
            actions.moveNetworkDevicesRequest(
                devicesToMove.map(d => ({
                    id: Number(d.id),
                    location_id: Number(locationId),
                    customer_id: Number(d.customer_id)
                }))
            )
        )
        setIsDevicesToMoveMode(false)
    }

    const onAddDevicesClick = (locationId, customerId) => {
        dispatch(actions.availableNetworkDevicesRequest(locationId, customerId))
        setIsDevicesToMoveMode(true)
    }

    const onQrIconClick = deviceSerial => {
        setCurrentDeviceSerial(deviceSerial)
        setIsOpenQrModal(true)
    }

    const onRestoreDevice = deviceId => {
        dispatch(actions.moveFromLocationNetworkDevices(deviceId))
    }

    const exportDevices = async fileType => {
        setIsExporting(true)
        const locationName = location.name
        const locale_key = localStorage.getItem(LOCAL_LOCALE_KEY)
        const params = {
            fileType,
            locale_key,
            locationId,
            locationName,
            with_children: isDevicesToMoveMode ? 0 : 1,
            ...filters,
            networkDevice: true
        }
        const blob = await getFileForExport(params)
        if (blob) {
            const fileName = `network-devices-export.${fileType}`
            downloadFile(blob, fileType, fileName)
        } else {
            dispatch(
                enqueueSnackbar({
                    message: locale.sagasMsgs.getDevicesEx,
                    options: {
                        variant: 'error'
                    }
                })
            )
        }
        setIsExporting(false)
    }

    useEffect(() => {
        if (!isNew && locationId)
            dispatch(
                actions.locationNetworkDevicesRequest(
                    locationId,
                    isDevicesToMoveMode,
                    {
                        ...prepareFilters(
                            filters,
                            reportSeverityGroups,
                            UserPermissions.isAllOriginalGranted()
                        )
                    }
                )
            )
    }, [locationId, isDevicesToMoveMode, filters])

    useEffect(() => {
        if (!isNew && locationId) dispatch(actions.locationRequest(locationId))
        dispatch(actions.locationNetworkDevicesSuccess(null))
    }, [locationId])

    useEffect(() => {
        return () => {
            dispatch(actions.locationNetworkDevicesSuccess(null))
        }
    }, [])

    return (
        <>
            {isExporting && (
                <div className={classes.loader}>
                    <Loading />
                </div>
            )}
            <div
                className={classNames(classes.wrapper, className, {
                    [`${classes.disabledWrapper}`]: isExporting
                })}>
                {!noTitle ? (
                    <PageTitle
                        title={locale.locations.devicesOnLocation}
                        className={classes.pageTitle}></PageTitle>
                ) : null}

                {!noFilters ? (
                    <div className={classes.filtersWrapper}>
                        <ExportMenu>
                            {({ handleClose }) => (
                                <>
                                    <ExportMenu.Csv
                                        locale={locale}
                                        onExport={fileType => {
                                            exportDevices(fileType)
                                            handleClose()
                                        }}
                                    />
                                    <ExportMenu.Excel
                                        locale={locale}
                                        onExport={fileType => {
                                            exportDevices(fileType)
                                            handleClose()
                                        }}
                                    />
                                    <ExportMenu.Pdf
                                        locale={locale}
                                        onExport={fileType => {
                                            exportDevices(fileType)
                                            handleClose()
                                        }}
                                    />
                                </>
                            )}
                        </ExportMenu>
                        <NetworkDeviceFilters
                            className={classes.deviceFilters}
                            locale={locale}
                            onChange={d}
                            filters={filters}
                        />
                        <div>
                            {isDevicesToMoveMode && canUpdate && (
                                <Button
                                    onClick={() =>
                                        onSaveMove(locationNetworkDevices)
                                    }>
                                    {locale.common.save}
                                </Button>
                            )}
                            {!isDevicesToMoveMode && canUpdate && (
                                <Button
                                    onClick={() =>
                                        onAddDevicesClick(
                                            locationId,
                                            location.customer_id
                                        )
                                    }>
                                    {locale.locations.addDevices}
                                </Button>
                            )}
                        </div>
                    </div>
                ) : null}

                {!isLoading && isEmpty(locationNetworkDevices) && (
                    <div>{locale.locations.noDevicesSetupYet}</div>
                )}

                {!isEmpty(locationNetworkDevices) && (
                    <NetworkDevicesTable
                        embeded={embeded}
                        isLoading={isLoading}
                        devices={locationNetworkDevices}
                        onQrIconClick={onQrIconClick}
                        isDevicesToMoveMode={isDevicesToMoveMode}
                        onRestoreDevice={onRestoreDevice}
                    />
                )}

                <DeviceSerialQrCodeModal
                    deviceSerial={currentDeviceSerial}
                    open={isOpenQrModal}
                    setOpen={setIsOpenQrModal}
                />
            </div>
        </>
    )
}

export default withRouter(LocationNetworkDevices)
